import { render, staticRenderFns } from "./Trots.vue?vue&type=template&id=68d75870&scoped=true&"
import script from "./Trots.vue?vue&type=script&lang=js&"
export * from "./Trots.vue?vue&type=script&lang=js&"
import style0 from "./Trots.vue?vue&type=style&index=0&id=68d75870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d75870",
  null
  
)

export default component.exports